import { BrowserRouter, Switch, Route } from 'react-router-dom';

import PrivateRoute from './components/common/PrivateRoute';
import CoreLayout from './components/core/CoreLayout';
import CoreRoutes from './components/core/CoreRoutes';
import LoginView from './components/auth/LoginView';

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path='/signin'>
          <LoginView />
        </Route>
        <PrivateRoute path='/'>
          <CoreLayout>
            <CoreRoutes />
          </CoreLayout>
        </PrivateRoute>
      </Switch>
    </BrowserRouter>
  );
}

export default App;
